import { Location } from '@ftr/contracts/api/location'
import { generateUuid } from '@ftr/contracts/type/shared'
import { AbstractBuilder } from '@ftr/foundation'

let locationCounter = 1

export class LocationBuilder extends AbstractBuilder<Location> {
  constructor(repeatable: boolean = false) {
    super({
      id: repeatable ? '112d29d9-3438-4ca0-b514-a106a1530ae0' : generateUuid(),
      name: repeatable ? 'Courtroom 27A' : `Location ${locationCounter++}`,
      courtSystemId: repeatable ? '112d29d9-3438-4ca0-b514-a106a1530ae0' : generateUuid(),
      isArchived: false,
      timeZoneId: undefined,
      automaticSttEnabled: false,
      trackIsolationInstallationDate: undefined,
      useDownmixedStt: false,
    })
  }

  withParent(): LocationBuilder {
    const location = new LocationBuilder().with({ courtSystemId: this.result.courtSystemId }).build()
    return this.with({
      parent: location,
      parentId: location.id,
    })
  }
}
